import React from 'react';
import { useCurrentRefinements } from 'react-instantsearch';
import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface CurrentRefinementsProps {
  className?: string;
}

export const CurrentRefinements: React.FC<CurrentRefinementsProps> = ({ 
  className = '' 
}) => {
  const { items, refine } = useCurrentRefinements();

  if (items.length === 0) {
    return null;
  }

  const formatRefinementLabel = (item: any) => {
    switch (item.attribute) {
      case 'software_type':
        return `Software: ${item.label}`;
      case 'genres':
        return `Genre: ${item.label}`;
      case 'artist_name':
        return `Artist: ${item.label}`;
      case 'is_free':
        return item.label === 'true' ? 'Free Only' : 'Paid Only';
      case 'featured':
        return item.label === 'true' ? 'Featured Only' : 'Not Featured';
      case 'price':
        return `Price: ${item.label}`;
      default:
        return item.label;
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-sm font-medium">Active filters:</span>
      {items.map((item) =>
        item.refinements.map((refinement) => (
          <Badge 
            key={`${item.attribute}-${refinement.value}`} 
            variant="secondary" 
            className="gap-1"
          >
            {formatRefinementLabel({ ...item, label: refinement.label })}
            <X 
              className="h-3 w-3 cursor-pointer" 
              onClick={() => refine(refinement)}
            />
          </Badge>
        ))
      )}
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={() => items.forEach(item => 
          item.refinements.forEach(refinement => refine(refinement))
        )}
      >
        Clear all
      </Button>
    </div>
  );
};